import React, { Component } from 'react';
import * as config from '../config';
class Pdfview extends Component {
  render() {
    return ( 
        <object width="100%" height="98%" data={config.URL_WEBSERVICE+"/api/files/"+this.props.files[0].duongdan} type="application/pdf"> </object>       
    );
  }
}
 
export default Pdfview;